import { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PageContext from './PageContext';
import PageDropdown from './PageDropdownCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import checkChange from '../functions/checkChange'; 
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditCompanyEntitlementsModal = () => {
    // get context variables from parent
    const {
        editEntitlementsModal, 
        setEditEntitlementsModal, 
        editEntitlementsRow, 
        roleList, 
        masterCompanyData, 
        getCompanyDetailsData,
        snackbarAlert,
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);
    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    // initialize role state
    const [statusTag, setStatusTag] = useState('Active');
    const [statusList, setStatusList] = useState(['Active', 'Inactive']);
    const [role, setRole] = useState('--select--');
    const [statusChange, setStatusChange] = useState(false);
    // useRef to determine initial render
    const initialRender = useRef(true);
    // initialize useRef for initial values
    const initialValues = useRef({});  

    // event handler for submit click
    const onSubmitClick = () => { 
        return new Promise((resolve, reject) => {
            let response; 
            // check for valid input 
            if ( role == '--select--' ){
                snackbarAlert(true, 'Error: Invalid input.', 'error');
                reject(); 
                return 
            }
            // set active variable from statusTag
            let active = false;
            if (statusTag == 'Active'){
                active = true; 
            }
            // remove params that have not changed
            let args = checkChange(initialValues, {
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                userroledescription: role,
                active: active, 
                userentitlementid: editEntitlementsRow['userentitlementid'], 
                userid: editEntitlementsRow['userid'], 
            }); 
            // all oldValues to body
            args['oldValues'] = initialValues.current; 
            // make PUT request
            PUT('/data/companyEntitlements', args).then(res => {
                console.log(res);
                response = res; 
                // hide modal
                setEditEntitlementsModal(editEntitlementsModal => editEntitlementsModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getCompanyDetailsData(company);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to run when editEntitlements row is changed
    useEffect(() => {
        console.log(editEntitlementsRow);
        // do not set role on initial render
        if (initialRender.current){
            initialRender.current = false;
        }
        else{
            // set role when row is changed
            setRole(role => role = editEntitlementsRow['userroledescription']);
            // set status tag based on active element of editEntitlementsRow
            if (editEntitlementsRow['active'] == true){
                setStatusTag(statusTag => statusTag = 'Active');
            }
            else {
                setStatusTag(statusTag => statusTag = 'Inactive');
            }
            // set initial values 
            initialValues.current = {
                userroledescription: editEntitlementsRow['userroledescription'], 
                active: editEntitlementsRow['active'], 
            }
        }
    }, [editEntitlementsRow]);

    return(
        <> 
            <CCOffcanvas
                title={`Edit Entitlements for User: ${editEntitlementsRow['userid']}`}
                show={editEntitlementsModal}
                onCanvasClose={()=>setEditEntitlementsModal(editEntitlementsModal => editEntitlementsModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* read only input to show user being edited */}
                        <PageDropdown tag='Status' value={statusTag} setValue={setStatusTag} list={statusList} width={'100%'} topAlignTypography={true}/>
                        {/* page dropdown to choose new role. do not show if status change */}
                        { statusTag == 'Active' ? 
                        <PageDropdown tag='Role' list={roleList} value={role} setValue={setRole} width={'100%'} topAlignTypography={true}/>
                        :<></>}
                        
                    </div>
                    {/* button to submit company entitlement edit */}
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            {/* <button className='entitlement-modal-button' onClick={(e)=>onSubmitClick(e)}>Submit</button> */}
                            <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setEditEntitlementsModal(editEntitlementsModal => editEntitlementsModal = false)}
                            />
                            <ApiRequestButton onButtonClick={onSubmitClick}/>
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditCompanyEntitlementsModal; 